import { computed, ref } from 'vue'
import { useRouteQuery } from '@vueuse/router'
import useRef from '@nicolaudie-group/ng-ui-kit/composables/useRef'
import dev from '@nicolaudie-group/ng-ui-kit/helpers/dev'
import useAutofix from './useAutofix'
import { SORT_ORDERS, DEFAULT_SORTORDER, getRoute } from './helpers'

function fixSortOrderParam(value) {
  // checkLimit('Fixing sortOrder', value)
  if (value === SORT_ORDERS.ASC || value === SORT_ORDERS.DESC) {
    return value
  }
  return DEFAULT_SORTORDER
}

function useSortParams({
  query = {},
  loading = false,
  ALL_SORTBY,
  DEFAULT_SORTBY,
} = {}) {
  const {
    enabled: queryEnabled = false,
    mode: queryMode,
  } = query

  function fixSortByParam(value) {
    // checkLimit('Fixing sortBy', value)
    if (ALL_SORTBY.includes(value)) {
      return value
    }
    return DEFAULT_SORTBY
  }

  const loadingRef = useRef(loading)

  function getSortRoute(route, { sortBy, sortOrder }) {
    return getRoute(route, { sortBy, sortOrder, page: undefined })
  }

  const sortBy = queryEnabled
    ? useRouteQuery('sortBy', DEFAULT_SORTBY, {
      mode: queryMode,
      // transform: { get: fixSortByParam, set: fixSortByParam },
      transform: fixSortByParam,
    })
    : ref(DEFAULT_SORTBY)

  const sortOrder = queryEnabled
    ? useRouteQuery('sortOrder', DEFAULT_SORTORDER, {
      mode: queryMode,
      // transform: { get: fixSortOrderParam, set: fixSortOrderParam },
      transform: fixSortOrderParam,
    })
    : ref(DEFAULT_SORTORDER)

  if (!queryEnabled) {
    useAutofix(sortBy, fixSortByParam)
    useAutofix(sortOrder, fixSortOrderParam)
  }

  function applySort(field, order) {
    dev.log('Applying sort', field, order)
    sortBy.value = field
    sortOrder.value = order
  }

  const sortProps = computed(() => {
    if (queryEnabled) {
      return {
        header: {
          router: queryEnabled,
          replace: queryEnabled ? queryMode === 'replace' : undefined,
          by: sortBy.value,
          order: sortOrder.value,
          readonly: loadingRef.value,
        },
      }
    }

    return {
      header: {
        by: sortBy.value,
        order: sortOrder.value,
        readonly: loadingRef.value,
        onToggle: applySort,
      },
    }
  })

  return {
    sortBy,
    sortOrder,
    applySort,
    getSortRoute,
    sortProps,
  }
}

export default useSortParams
